import { dataFileAdd } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileAdd = /*#__PURE__*/createIcon(dataFileAdd)
export default IconFileAdd
